<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
           <a-form-model
      layout="inline"
      label-position="top"
      :model="searchForm.data">

          <a-form-model-item label="品牌名">
            <a-input v-model="searchForm.data.brandName" style="width: 150px" allowClear placeholder="请输入品牌名"/>
          </a-form-model-item>
           <!-- <a-form-model-item label="品牌名">
            <a-input v-model="searchForm.data.brandName" style="width: 150px" allowClear placeholder="品牌名"/>
          </a-form-model-item> -->
          <a-form-model-item label="操作">
            <a-space>
              <a-button
                type="primary"
                        @click="getGoodsBrandList">{{ $t('SEARCH') || '查询' }}
              </a-button>

                <a-button type="primary" @click="addGoodsBrand">
          {{ $t('ADD') || '添加' }}
        </a-button>

            </a-space>
          </a-form-model-item>
        </a-form-model>

      </div>
      <a-table
        :scroll="{ y: 'calc(100vh - 345px)' }"
        childrenColumnName="[]"
        row-key="id"
         :pagination="false"
        :data-source="table.data"
        style="width: 100%">
        <a-table-column
          data-index="name"
          title="名称"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="coverPath"
          title="图片"
          width="180">
          <template slot-scope="text,record">
            <a-avatar
              :src="record.coverPath"
              class="antd-pro-global-header-index-avatar"/>
          </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <a-button
              type="link"
          @click="editGoodsBrand(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button type="link" @click="viewGoodsBrand(record.id)">详情
            </a-button>
            <a-divider type="vertical"/>
            <a-button type="link" @click="deleteGoodsBrand(record.id)">{{ $t('DELETE') || '删除' }}
            </a-button>
            <a-divider type="vertical"/>
            <!-- <a-button type="link" @click="upGoodsBrand(record.id)">上移
            </a-button>
            <a-divider type="vertical"/>
            <a-button type="link" @click="downGoodsBrand(record.id)">下移
            </a-button> -->
          </template>
        </a-table-column>
      </a-table>
      <a-pagination
      class ="pagination-class"
                  v-model="table.query.page"
                    :total="table.query.total"
                    show-size-changer
                    :page-size="table.query.size"
                    :pageSizeOptions="['5','20','50','100']"
                    @showSizeChange="handleSizeChange"
                    @change="handleSizeChange">
        <template
                  slot="buildOptionText"
                  slot-scope="props">
          <span>{{ props.value }}条/页</span>
        </template>
      </a-pagination>
    </div>
    <a-modal
      :footer="null"
      title="商品分类编辑"
      v-model="form.visible">
      <GoodsBrand-edit
        v-if="form.visible"
        :goods-brand-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </GoodsBrand-edit>
    </a-modal>
    <a-modal
:footer="null"
             title="商品属性"
             append-to-body
             v-model="attributeForm.visible">
      <goods-attribute-list
        v-if="attributeForm.visible"
        :goods-brand-id="attributeForm.data.id">
      </goods-attribute-list>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryGoodsBrands,
  _deleteGoodsBrand,
  // _downGoodsBrand,
  // _upGoodsBrand,
} from '@/api/goodsBrandApi';
import GoodsBrandEdit from './GoodsBrandEdit.vue';
import GoodsAttributeList from '../goodsAttribute/GoodsAttributeList.vue';

async function getGoodsBrandList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  if (this.searchForm.data.brandName !== '') {
    this.table.query.page = 1;
  }
  const result = await _queryGoodsBrands({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    name: this.searchForm.data.brandName,
    direction,
  });
  this.table.data = result.content;
  // this.table.data = result.content.filter(x => !x.parentId)
  //   .map(x => (
  //     {
  //       ...x,
  //       children: result.content.filter(y => y.parentId === x.id),
  //     }
  //   ))
  this.table.query.total = result.totalElements;
}

function editGoodsAttribute(id) {
  this.attributeForm.data.id = id;
  this.attributeForm.visible = true;
}

function addGoodsBrand() {
  this.form.data.id = null;
  this.form.visible = true;
}

function handleSizeChange(current, pageSize) {
  this.table.query.page = current;
  this.table.query.size = pageSize;
  this.getGoodsBrandList();
}

function editGoodsBrand(GoodsBrandId) {
  this.form.data.id = GoodsBrandId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getGoodsBrandList();
}
function viewGoodsBrand(brandId) {
  this.$router.push(`/goods-brand/${brandId}`);
}

async function deleteGoodsBrand(GoodsBrandId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      const result = await _deleteGoodsBrand(GoodsBrandId);
      if (result) {
        this.$message.success('删除成功');
        this.getGoodsBrandList();
      }
    },
  });
}

export default {
  name: 'GoodsBrandList',
  components: {
    GoodsAttributeList,
    GoodsBrandEdit,
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      attributeForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      searchForm: {
        data: {
          brandName: '',
        }
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 10,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getGoodsBrandList,
    editGoodsAttribute,
    deleteGoodsBrand,
    editGoodsBrand,
    addGoodsBrand,
    handleSizeChange,
    // upGoodsBrand,
    // downGoodsBrand,
    closeForm,
    viewGoodsBrand,
  },
  created() {
    this.getGoodsBrandList();
  },
};
</script>

<style scoped>

</style>
